import { SupportEmailField } from '../../../components/SupportEmailField/SupportEmailField';

// First version of account deletion: users email support, so this card only explains how.
// Self-serve deletion will replace the email field with a Delete button later.
export const DeleteAccountCard = () => {
  return (
    <div className="rounded-lg border border-gray-300 p-4 border-solid custom-card">
      <div className="text-brand-grey-dark text-base font-semibold leading-normal">Delete your account</div>

      <div className="text-brand-grey-dark text-sm font-medium leading-5">
        <p className="m-0">To request permanent account deletion, please send us an email at the address below.</p>
        <p className="m-0">
          Deleting your account will remove your access to every Organization linked to that email address.
        </p>
      </div>

      <div className="flex justify-end">
        <SupportEmailField className="w-[292px]" />
      </div>
    </div>
  );
};
